module.exports = __webpack_public_path__ + "a812038b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav_logo.png
// module id = 896
// module chunks = 0 1 2 3 4 5